import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsStackbitComponent } from './simple-icons-stackbit.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsStackbitComponent ],
    exports:      [ SimpleIconsStackbitComponent ],
    bootstrap:    []
})
export class SimpleIconsStackbitModule {}
